import React, { Ref } from 'react';

import { useClassnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import { Text } from '@lumapps/lumx/react';

import './index.scss';

export interface WaffleItemProps {
    /** className to be added to the wrapping div */
    className?: string;
    /** Bookmark title to display */
    title: string;
    /** Bookmark link to display */
    link: string;
    /** Bookmark icon to display */
    icon: string;
    /** Bookmark id to display */
    id?: string;
    /** reference to the bookmark link */
    linkRef?: Ref<HTMLAnchorElement>;
}

const CLASSNAME = 'bookmark';
const SCOPE = 'bookmark';

/**
 * This component display a links with an icon.
 */
export const WaffleItem: React.FC<WaffleItemProps> = ({ className = '', title, linkRef, link, icon, id }) => {
    const { element, block } = useClassnames(CLASSNAME);
    const { get } = useDataAttributes(SCOPE);

    return (
        <li className={block([className])} {...get({ element: 'item' })} id={id}>
            <a className={element('link')} href={link} target="_blank" rel="noopener noreferrer" ref={linkRef}>
                <div className={element('icon')} style={{ backgroundImage: `url(${icon})` }} />

                <Text as="span" typography="caption" className={element('title')}>
                    {title}
                </Text>
            </a>
        </li>
    );
};
